import { Page, useViewerTenant } from "@workflows/ui";
import * as React from "react";
export interface CorePageProps {
  children?: React.ReactNode;
}
export function CorePage({
  children
}: CorePageProps): JSX.Element {
  const {
    userType
  } = useViewerTenant(true);
  return <Page narrow={userType === "anonymous"}>{children}</Page>;
}